import { ComponentProps } from "react";

export const NetflixAdsLogo = ({
  primarySectionProps,
  secondarySectionProps,
  ...props
}: {
  primarySectionProps?: ComponentProps<"g">;
  secondarySectionProps?: ComponentProps<"g">;
} & ComponentProps<"svg">) => (
  <svg
    aria-label="Netflix Ads"
    viewBox="0 0 878 168"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g {...secondarySectionProps}>
      <path
        d="M793.312 117.042H821.933C822.243 125.884 823.407 131.934 825.423 135.191C827.595 138.449 830.775 140.078 834.963 140.078C842.72 140.078 846.598 135.269 846.598 125.651V121.23C846.598 115.335 845.59 111.069 843.573 108.432C841.711 105.64 837.988 102.77 832.404 99.8227L823.096 94.7036C813.634 89.7396 806.421 83.6898 801.457 76.554C796.648 69.4183 794.243 60.2659 794.243 49.097V43.7452C794.243 29.7839 797.811 19.0028 804.947 11.4017C812.238 3.80055 822.631 0 836.127 0C850.398 0 860.792 4.18837 867.307 12.5651C873.822 20.9418 877.002 32.7313 876.847 47.9335H848.227C848.072 40.4875 846.986 35.2909 844.969 32.3435C843.108 29.241 840.238 27.6898 836.36 27.6898C832.947 27.6898 830.232 28.9308 828.216 31.4128C826.199 33.8947 825.191 37.8504 825.191 43.2798V46.5374C825.191 51.3463 826.199 55.1468 828.216 57.9391C830.232 60.7313 833.722 63.5235 838.686 66.3158L847.994 71.2022C855.13 75.0803 860.869 79.1136 865.213 83.3019C869.556 87.3352 872.736 92.0665 874.753 97.4959C876.77 102.925 877.778 109.596 877.778 117.507V123.557C877.778 137.363 874.21 148.222 867.074 156.133C860.094 164.044 849.468 168 835.196 168C820.925 168 810.376 163.889 803.551 155.668C796.88 147.291 793.468 134.416 793.312 117.042Z"
        fill="currentColor"
      />
      <path
        d="M695.221 3.02637H738.5C752.927 3.02637 764.018 7.60255 771.775 16.7549C779.686 25.9073 783.642 38.5499 783.642 54.6829V113.32C783.642 129.298 779.686 141.94 771.775 151.248C764.018 160.4 752.927 164.977 738.5 164.977H695.221V3.02637ZM738.5 136.356C747.808 136.356 752.462 128.988 752.462 114.251V53.5194C752.462 38.9377 747.808 31.6469 738.5 31.6469H725.935V136.356H738.5Z"
        fill="currentColor"
      />
      <path
        d="M618.289 3.02539H652.028L685.768 164.976H655.053L649.003 129.607H620.383L614.333 164.976H584.316L618.289 3.02539ZM634.809 47.7013L625.037 102.848H644.35L634.809 47.7013Z"
        fill="currentColor"
      />
    </g>
    <g {...primarySectionProps}>
      <path
        d="M505.851 78.1843L475.834 3.02637H509.574L524.233 50.4945L538.892 3.02637H571.003L540.987 78.1843L574.726 164.977H540.754L522.837 110.295L504.688 164.977H472.111L505.851 78.1843Z"
        fill="currentColor"
      />
      <path
        d="M431.393 3.02637H462.107V164.977H431.393V3.02637Z"
        fill="currentColor"
      />
      <path
        d="M350.922 3.02637H381.637V136.356H421.659V164.977H381.637H350.922V3.02637Z"
        fill="currentColor"
      />
      <path
        d="M273.359 3.02637H341.071V31.1815H304.074V72.1344H339.442V100.522H304.074V164.977H273.359V3.02637Z"
        fill="currentColor"
      />
      <path
        d="M205.841 31.6469H179.314V3.02637H263.314V31.6469H236.788V164.977H205.841V31.6469Z"
        fill="currentColor"
      />
      <path
        d="M98.8438 3.02637H169.581V31.1815H129.093V68.4114H167.719V96.7992H129.093V136.821H170.046V164.977H98.8438V3.02637Z"
        fill="currentColor"
      />
      <path
        d="M0.222656 3.02637H28.3778L61.4193 94.9377V3.02637H89.1091V164.977H60.7213L27.9124 73.7632V164.977H0.222656V3.02637Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
